export const socialLinks = {
  github: "https://github.com/asseph",
  discord: "https://discordapp.com/users/367009301090402325",
  linkedin: "https://www.linkedin.com/in/david-kano",
  twitter: "https://twitter.com/sol_maxi_",
  telegram: "https://t.me/asseph_1994",
  twitterfollow: "https://twitter.com/intent/follow?screen_name=sol_maxi_"
};
